define("calendar/services/bttp", ["exports", "@ember/service", "ember-concurrency-decorators", "later/utils/fetch"], function (_exports, _service, _emberConcurrencyDecorators, _fetch) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2;

  0; //eaimeta@70e063a35619d71f0,"@ember/service",0,"ember-concurrency-decorators",0,"later/utils/fetch"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const MINIMUM_FOLLOWERS = 100;
  let BttpService = (_class = class BttpService extends _service.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor2, this);
    }

    get currentProfile() {
      return this.selectedSocialProfiles.firstProfile;
    }

    get requiredFollowerCount() {
      return MINIMUM_FOLLOWERS;
    }

    get canBttp() {
      var _this$currentProfile;

      switch ((_this$currentProfile = this.currentProfile) === null || _this$currentProfile === void 0 ? void 0 : _this$currentProfile.profileType) {
        case 'tiktok':
          return this.auth.currentAccount.canTiktokBttp;

        case 'instagram':
          return this.auth.currentAccount.canBttp;

        default:
          return false;
      }
    }

    get isValidSocialProfile() {
      var _this$currentProfile2;

      switch ((_this$currentProfile2 = this.currentProfile) === null || _this$currentProfile2 === void 0 ? void 0 : _this$currentProfile2.profileType) {
        case 'tiktok':
          return this.auth.currentAccount.rolloutTiktokBttp;

        case 'instagram':
          return true;

        default:
          return false;
      }
    }

    get analyticsReportName() {
      var _this$currentProfile3;

      switch ((_this$currentProfile3 = this.currentProfile) === null || _this$currentProfile3 === void 0 ? void 0 : _this$currentProfile3.profileType) {
        case 'tiktok':
          return 'tt-bttp';

        case 'instagram':
          return 'ig-bttp';

        default:
          return '';
      }
    }

    *generateBttpReport() {
      var _this$currentProfile4;

      return yield (0, _fetch.fetch)("/api/v2/analytics_reports", {
        method: 'POST',
        body: {
          analytics_report: {
            name: this.analyticsReportName,
            social_profile_id: (_this$currentProfile4 = this.currentProfile) === null || _this$currentProfile4 === void 0 ? void 0 : _this$currentProfile4.id
          }
        }
      });
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "generateBttpReport", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "generateBttpReport"), _class.prototype)), _class);
  _exports.default = BttpService;
});